import type { DeepString } from "@/lib/i18n";

/**
 * WShopRecomendedProducts - stringi chrome okna (naglowek + CTA).
 * Etykiety kafelka (badge, status, cena, "do koszyka") pochodza z
 * `<ProductCard />` (wspoldzielony i18n `components/ui/ProductCard`).
 */
export const pl = {
  title: "Polecane produkty",
  showAll: "Zobacz wszystkie",
  noProducts: "Brak polecanych produktów.",
} as const;

export type WShopRecomendedProductsTranslations = DeepString<typeof pl>;
